var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field)?_c('div',[_c('div',_vm._b({ref:"editor",staticClass:"form-control",attrs:{"contenteditable":"true"},on:{"input":_vm.onInput}},'div',_vm.$attrs,false),[_vm._v(_vm._s(_vm.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }